module.exports = __webpack_public_path__ + "assets/img/manager-list.96d6b7fc.svg";